module.exports = __webpack_public_path__ + "files/SPIADI2026 - RÉA INF ADI - AD PED - Guide Technique (Version 2).05f66151d30df25b34ede2ac224d3ea3.pdf";